import React, { useMemo } from 'react'
import moment from 'moment'
import useToggle from 'hooks/useToggle'
import TextLink from 'components/Luxkit/TextLink'
import LineTagAltIcon from 'components/Luxkit/Icons/line/LineTagAltIcon'
import USPModal from './USPModal'

interface Props {
  offer: App.Offer;
}

function FlashHotelWePriceMatch(props: Props) {
  const { offer } = props

  const [open, , openModal, closeModal] = useToggle()
  const bookBy = useMemo(() => moment(offer.bookByDate), [offer.bookByDate])
  const travelUntil = useMemo(() => moment(offer.travelToDate), [offer.travelToDate])

  return (<>
    <TextLink
      variant="highlight"
      size="small"
      underline={false}
      startIcon={<LineTagAltIcon />}
      onClick={openModal}
    >
      We price match
    </TextLink>
    <USPModal open={open} onClose={closeModal} modalType="bestPrice" bookBy={bookBy} travelUntil={travelUntil} />
  </>)
}

export default FlashHotelWePriceMatch
